module.exports = __webpack_public_path__ + "img/U_Inventory_frame2_bg.2fdcc888.png";